import { FormInitializerReturnTypeZod, ValidationMessageKeys } from 'src/Configuration/validation'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { ChangeWarrantyForm, ChangeWarrantyFormValidationObject } from 'src/Libs/installation-details/models/change-warranty.model'
import { z } from 'zod'

const MIN_STRING_LENGTH = 3
const MAX_STRING_LENGTH = 1000

/**
 *  Initializes the form to change the warranty of an installation
 * @returns initialValues and validationSchema for changing the warranty of an installation form
 */
export const useChangeWarrantyFormInitializer = (
  notes: string | undefined
): FormInitializerReturnTypeZod<ChangeWarrantyForm, ChangeWarrantyFormValidationObject> => {
  const { t } = useCustomTranslation()

  const initialValues: ChangeWarrantyForm = {
    notes: notes ?? '',
  }

  const validationSchema = z.object({
    notes: z
      .string()
      .min(MIN_STRING_LENGTH, t(ValidationMessageKeys.lengthMin, { value: MIN_STRING_LENGTH }))
      .max(MAX_STRING_LENGTH, t(ValidationMessageKeys.lengthMax, { value: MAX_STRING_LENGTH }))
      .trim()
      .optional()
      .or(z.literal(''))
      .nullable(),
  })

  return { initialValues, validationSchema }
}
